<ng-container *ngIf="costUnitState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{ "app.dialog.cost-unit-group-contribution-margin-level-assignments.title.header" | translate :{costUnitGroupName: state.selectedCostUnitGroup.name} }}
    </h1>
    <div mat-dialog-content>
        <div class="contribution-margin-level-selection">
            <mat-generic-input
                [fields]="layout.selectFields"
                (inputFormGroupChange)="formGroupChange($event)">
            </mat-generic-input>
            <button mat-mini-fab
                    color="primary"
                    [disabled]="!(contributionMarginLevelSelected | async)"
                    (click)="assignContributionMarginLevel()">
                <mat-icon>add</mat-icon>
            </button>
        </div>

    </div>
    <mat-progress-bar color="accent" [style.visibility]="state.isLoadingAssignedContributionMarginLevels ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>

    <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.contribution-margin-level.name.label" | translate }}</th>
            <td mat-cell *matCellDef="let element">
                {{element.name}}
            </td>
        </ng-container>

        <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.contribution-margin-level.order.label" | translate }}</th>
            <td mat-cell *matCellDef="let element">
                {{element.order}}
            </td>
        </ng-container>
        <ng-container matColumnDef="delete-button">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button color="warn" mat-icon-button (click)="onDeleteContributionMarginLevelAssignment(element)">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="layout.columns"></tr>
        <tr mat-row *matRowDef="let row; columns: layout.columns;"></tr>
    </table>
    <mat-paginator [pageSize]="10"></mat-paginator>
    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.cancel.label" | translate }}</button>
    </div>
</ng-container>
